var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-center items-center w-full h-screen text-gray-500 text-2xl"},[_vm._v(" 页面异常,请联系管理员 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }